exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qrcode[data-v-0ad6b3f1]{width:70px;height:70px}", ""]);

// exports
